(function () {
  'use strict';

  angular
      .module('tfc.Form')
      .directive('tfcConfirmInput', tfcConfirmInput);

  // @ngInject
  function tfcConfirmInput() {
    return {
      restrict : 'A',
      require : ['ngModel', '^form'],
      link : function ($scope, $el, $attrs, ctrls) {
        var ngModel = ctrls[0],
            form = ctrls[1];
        var name = $attrs.tfcConfirmInput,
            otherNgModel = form[name];

        if (!otherNgModel) {
          throw new Error('Cannot find field:' + name);
        }

        $scope.$watch(
            function () {
              return ngModel.$dirty && otherNgModel.$isEmpty(otherNgModel.$modelValue);
            },
            function (hasBeenCleared) {
              if (hasBeenCleared) {
                // reset this field when the other field is cleared
                ngModel.$setViewValue('');
                ngModel.$setPristine();
                ngModel.$render();
              }
            }
        );

        $scope.$watch(
            function () {
              // don't validate until this field has been touched
              return ngModel.$pristine
                  || form[name].$modelValue === ngModel.$modelValue;
            },
            function (valid) {
              ngModel.$setValidity('confirm', valid);
            }
        );
      }
    };
  }

})();
